var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddDevice = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9047 26.238H18.0952V28.0476H19.9047V26.238Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3811 26.238H13.5715V28.0476H15.3811V26.238Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8571 26.238H9.04761V28.0476H10.8571V26.238Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.4287 26.238H22.6191V28.0476H24.4287V26.238Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.9523 26.238H27.1428V28.0476H28.9523V26.238Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.7005 17.641L31.3672 8.05057C31.0324 7.543 30.4651 7.2381 29.8571 7.2381H27.0533C26.6009 3.173 23.1474 0 18.9638 0C14.7802 0 11.3258 3.173 10.8743 7.2381H8.36905C7.7719 7.2381 7.21276 7.53305 6.87529 8.02614L0.315762 17.6166C0.110381 17.917 0 18.2735 0 18.6381V32.4303C0 34.504 1.70729 36.1905 3.80633 36.1905H34.1928C36.2927 36.1905 38 34.504 38 32.4303V18.6381C38 18.2834 37.896 17.9369 37.7005 17.641ZM18.9638 1.80952C22.4616 1.80952 25.2971 4.64505 25.2971 8.14286C25.2971 11.6407 22.4616 14.4762 18.9638 14.4762C15.466 14.4762 12.6305 11.6407 12.6305 8.14286C12.6305 4.64505 15.466 1.80952 18.9638 1.80952ZM8.36905 9.04762H10.8743C11.3267 13.1127 14.7802 16.2857 18.9638 16.2857C23.1474 16.2857 26.6018 13.1127 27.0533 9.04762H29.8571L35.8322 18.0952H2.18048L8.36905 9.04762ZM34.1937 34.381H3.80633C2.70343 34.381 1.80952 33.5079 1.80952 32.4303V19.9048H36.1905V32.4303C36.1905 33.5079 35.2966 34.381 34.1937 34.381Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.6666 21.7144H6.33324C5.80757 21.7144 5.30814 21.9424 4.96434 22.3405C4.62053 22.7385 4.46672 23.2651 4.54272 23.7854L5.59857 31.0235C5.72795 31.9119 6.49067 32.5715 7.3891 32.5715H30.6116C31.5101 32.5715 32.2728 31.9119 32.4021 31.0235L33.458 23.7854C33.534 23.2651 33.3802 22.7385 33.0364 22.3405C32.6926 21.9424 32.1922 21.7144 31.6666 21.7144ZM7.3891 30.762L6.33324 23.5239H31.6666L30.6107 30.762H7.3891Z",
    fill: "#D7272F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.059 11.762H19.8685V9.04774H22.5828V7.23821H19.8685V4.52393H18.059V7.23821H15.3447V9.04774H18.059V11.762Z",
    fill: "#D7272F"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddDevice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-device.34727186.svg";
export { ForwardRef as ReactComponent };